import { americanToDecimal, decimalToAmerican } from "@/utils/calculators/odds-utils";

export type OddsRange = { readonly minOdds: number | null; readonly maxOdds: number | null };

export function parseAmericanBound(value: unknown): number | null {
  const text = typeof value === "number" ? String(value) : typeof value === "string" ? value.trim() : "";
  if (!/^[+-]?\d+$/.test(text)) return null;
  const odds = Number(text);
  return Number.isSafeInteger(odds) && Math.abs(odds) >= 100 ? odds : null;
}

export function orderOddsRange(minOdds: number | null, maxOdds: number | null): OddsRange {
  if (minOdds !== null && maxOdds !== null && americanToDecimal(minOdds) > americanToDecimal(maxOdds)) {
    return { minOdds: maxOdds, maxOdds: minOdds };
  }
  return { minOdds, maxOdds };
}

export function oddsRangeActive(range: OddsRange): boolean {
  return range.minOdds !== null || range.maxOdds !== null;
}

export function oddsInRange(american: number | null | undefined, range: OddsRange): boolean {
  if (!oddsRangeActive(range)) return true;
  if (typeof american !== "number" || !Number.isFinite(american) || american === 0) return false;
  const decimal = americanToDecimal(american);
  if (range.minOdds !== null && decimal < americanToDecimal(range.minOdds) - 1e-9) return false;
  if (range.maxOdds !== null && decimal > americanToDecimal(range.maxOdds) + 1e-9) return false;
  return true;
}

export function fairAmerican(hitPct: number | null): number | null {
  return hitPct !== null && hitPct > 0 && hitPct < 100 ? decimalToAmerican(100 / hitPct) : null;
}

export function americanText(odds: number): string {
  return odds > 0 ? `+${odds}` : String(odds);
}

export function oddsRangeText(range: OddsRange): string | null {
  const { minOdds, maxOdds } = range;
  if (minOdds !== null && maxOdds !== null) return `${americanText(minOdds)} to ${americanText(maxOdds)}`;
  if (minOdds !== null) return `${americanText(minOdds)} and up`;
  if (maxOdds !== null) return `up to ${americanText(maxOdds)}`;
  return null;
}
